import { ProgramNames } from '../../../models/programs/Programs'
import { ProgramCustomerPropertyId } from '../../common/constants/customerProgram'
import { TREATMENT_OPTIONS } from '../../common/constants/treatmentOptions'
import { ProgramDisplayLabels } from '../messages'
import { ProgramConfig } from '../types'

/**
 * Neuropsychological Evaluations is a "shell" program: it wires the
 * `neuropsychologicalEvaluations` customer property to its triage treatment option
 * so the program can be surfaced in treatment recommendations and the coverage section,
 * and so HPI eligibility checks are scoped to this program rather than falling back to
 * customer-wide checks.
 *
 * It has no direct booking flow (members are routed to the neurodiversity contact page)
 * and no Lyra Care sessions. Hence `blendedCareProgramId` is null and there is no
 * sessionTypeConfig/noteContentMetadataName.
 */
export const NEURO_PSYCH_EVALS_PROGRAM = {
  programName: ProgramNames.NeuroPsychologicalEvaluations,
  blendedCareProgramId: null,
  customerPropertyId: ProgramCustomerPropertyId.neuropsychologicalEvaluations,

  displayLabels: {
    default: ProgramDisplayLabels.neuropsychologicalEvaluations,
    short: 'Neuro Evals',
    clientProfile: 'Neuro Evals',
    daClientList: 'Neuro Evals',
    sessionSummary: 'neuropsychological evaluation',
  },

  associatedProviderTypes: [],
  associatedProviderModalities: [],

  canRescheduleAppointment: false,
  selfPayEligible: false,

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [
      TREATMENT_OPTIONS.NEUROPSYCHOLOGICAL_EVALUATIONS,
      TREATMENT_OPTIONS.NEUROPSYCHOLOGICAL_EVALUATIONS_CHILD,
    ],
    isFullTreatmentOption: true,
  },

  consents: [],
} satisfies ProgramConfig
